import React from 'react';
import PropTypes from 'prop-types';
import Radios from './Radios';

function YesNoRadio(props) {
  const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ];

  return <Radios {...props} options={yesNoOptions} />;
}

YesNoRadio.propTypes = {
  ...Radios.propTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

export default YesNoRadio;
